import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Link } from 'foundations-components/transitional/components/Link';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Patt... Remove this comment to see the full error message
import UrlPattern from 'PatternValidationJS/patterns/Url';
import { ERROR_TYPES, NAV_ITEMS } from 'knowledge-content-ui/constants/TemplateEditorConstants';
import { DEFAULT_FOOTER_COMPANY_LOGO_HEIGHT, DEFAULT_HEADER_COMPANY_LOGO_HEIGHT } from 'knowledge-content-ui/records/KnowledgeBaseSettingsRecord';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = key => `knowledgeContentUI.templateEditor.fields.${key}`;
function I18nText(messageKey) {
  return I18n.text(i18nKey(messageKey));
}
function validateRequiredField(value, fieldName) {
  if (!value) {
    return {
      errorType: ERROR_TYPES.FIELD_IS_REQUIRED,
      fieldName,
      options: {}
    };
  }
  return undefined;
}
function validateUrl(value, fieldName, options) {
  if (!UrlPattern.test(value)) {
    return {
      errorType: ERROR_TYPES.INVALID_URL,
      fieldName,
      options
    };
  }
  return undefined;
}
function getNetworkTypeText(networkType) {
  return I18n.text(`knowledgeContentUI.templateEditor.updateTemplateErrorsTooltip.networkType.${networkType}`);
}
const getNavBarModule = ({
  hasSupportForm,
  shouldShowCustomerPortalLinkToggle,
  shouldShowSignInLinkToggle,
  supportFormId
}) => {
  const kbChildren = [{
    name: 'headerCompanyLogo',
    label: I18nText('headerCompanyLogo.label'),
    help_text: I18nText('headerCompanyLogo.helpText'),
    type: 'logo',
    _defaultHeight: DEFAULT_HEADER_COMPANY_LOGO_HEIGHT,
    _maxHeight: 50
  }, {
    name: 'name',
    label: I18nText('name.label'),
    help_text: I18nText('name.helpText'),
    type: 'text',
    required: true,
    _validate: value => {
      return {
        name: validateRequiredField(value, 'name')
      };
    },
    _requiresPreviewRefresh: true
  }, {
    name: 'headerKnowledgeBaseNameURL',
    label: null,
    type: 'readOnlyInput'
  }, {
    name: 'companyWebsiteLinkText',
    label: I18nText('companyWebsiteLinkText.label'),
    type: 'text',
    _requiresPreviewRefresh: true
  }, {
    name: 'companyWebsiteLink',
    label: I18nText('companyWebsiteLink.label'),
    type: 'text'
  }];
  if (shouldShowCustomerPortalLinkToggle) {
    const tooltipLink = /*#__PURE__*/_jsx(Link, {
      external: true,
      href: "https://knowledge.hubspot.com/knowledge-base/customize-your-knowledge-base-appearance",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('customerPortalLink.tooltipLink')
      })
    });
    kbChildren.push({
      name: 'customerPortalLinkEnabled',
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ name: string; _label: string; ... Remove this comment to see the full error message
      _label: I18nText('customerPortalLink.label'),
      helpText: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: i18nKey('customerPortalLink.tooltip'),
        options: {
          tooltipLink
        }
      }),
      type: 'boolean',
      _requiresPreviewRefresh: true
    });
  }
  if (shouldShowSignInLinkToggle) {
    const tooltipLink = /*#__PURE__*/_jsx(Link, {
      external: true,
      href: "https://knowledge.hubspot.com/knowledge-base/customize-your-knowledge-base-appearance",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('signInLink.tooltipLink')
      })
    });
    kbChildren.push({
      name: 'signInLinkEnabled',
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ name: string; _label: string; ... Remove this comment to see the full error message
      _label: I18nText('signInLink.label'),
      helpText: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: i18nKey('signInLink.tooltip'),
        options: {
          tooltipLink
        }
      }),
      type: 'boolean',
      _requiresPreviewRefresh: true
    });
  }
  kbChildren.push({
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ id: string; name: string; type... Remove this comment to see the full error message
    id: 'supportFormId',
    name: 'supportFormId',
    type: 'support_form_id',
    label: null,
    _requiresPreviewRefresh: true
  });
  if (hasSupportForm && supportFormId) {
    kbChildren.push({
      name: 'supportFormTitle',
      label: I18nText('supportFormTitle.label'),
      type: 'text',
      _requiresPreviewRefresh: true
    });
  }
  return {
    fields: [{
      id: 'themeSettings__nav_bar',
      name: 'themeSettings',
      type: 'group',
      children: [{
        name: 'nav_bar_link_color',
        label: I18nText('navBarLinkColor.label'),
        help_text: I18nText('navBarLinkColor.helpText'),
        type: 'color'
      }]
    }, {
      id: 'knowledgeBaseSettings__nav_bar',
      name: 'knowledgeBaseSettings',
      type: 'group',
      children: kbChildren
    }]
  };
};
const getFooterModule = () => {
  const children = [{
    name: 'footerCompanyLogo',
    label: I18nText('footerCompanyLogo.label'),
    type: 'logo',
    _defaultHeight: DEFAULT_FOOTER_COMPANY_LOGO_HEIGHT,
    _maxHeight: 55
  }, {
    id: 'footerMessage',
    name: 'footerMessage',
    label: I18nText('footerMessage.label'),
    help_text: I18nText('footerMessage.helpText'),
    type: 'text'
  }, {
    id: 'footerLinks',
    label: I18nText('footerLinks.label'),
    name: 'footerLinks',
    children: [{
      type: 'text',
      id: 'footerLinks__linkName',
      name: 'name',
      default: '',
      required: true,
      label: I18nText('footerLinks.linkText.label'),
      _validate: (footerLinkName, keyPath, oldModuleValues) => {
        if (oldModuleValues) {
          const footerLinkIndex = keyPath[2];
          return {
            [`footerLink-${footerLinkIndex}-name`]: validateRequiredField(footerLinkName, 'footerLinkName')
          };
        }
        return {};
      }
    }, {
      type: 'text',
      id: 'footerLinks__linkUrl',
      name: 'url',
      default: '',
      required: true,
      label: I18nText('footerLinks.linkURL.label'),
      _validate: (footerLinkUrl, keyPath, oldModuleValues) => {
        if (oldModuleValues) {
          const footerLinkIndex = keyPath[2];
          return {
            [`footerLink-${footerLinkIndex}-url`]: validateRequiredField(footerLinkUrl, 'footerLinkUrl') ||
            // @ts-expect-error ts-migrate(2554) FIXME: Expected 3 arguments, but got 2.
            validateUrl(footerLinkUrl, 'footerLinkUrl')
          };
        }
        return {};
      }
    }],
    type: 'group',
    occurrence: {
      min: 0,
      sorting_label_field: 'footerLinks__linkName'
    },
    _requiresPreviewRefresh: true,
    _validate: (footerLinksValues, keyPath, oldModuleValues) => {
      const errors = {};
      if (oldModuleValues) {
        const oldFooterLinksValues = oldModuleValues.getIn(keyPath);
        for (let idx = 0; idx < oldFooterLinksValues.length; idx++) {
          // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          errors[`footerLink-${idx}-name`] = undefined;
          // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          errors[`footerLink-${idx}-url`] = undefined;
        }
      }
      footerLinksValues.reduce((linkErrors, value, idx) => {
        linkErrors[`footerLink-${idx}-name`] = validateRequiredField(value.name, 'footerLinkName');
        linkErrors[`footerLink-${idx}-url`] = validateRequiredField(value.url, 'footerLinkUrl') ||
        // @ts-expect-error ts-migrate(2554) FIXME: Expected 3 arguments, but got 2.
        validateUrl(value.url, 'footerLinkUrl');
        return linkErrors;
      }, errors);
      return errors;
    }
  }, {
    id: 'socialNetworkUrls',
    label: I18nText('socialNetworkUrls.label'),
    name: 'socialNetworkUrls',
    children: [{
      choices: [['FACEBOOK', I18nText('socialNetworkUrls.facebook')], ['TWITTER', I18nText('socialNetworkUrls.twitter')], ['INSTAGRAM', I18nText('socialNetworkUrls.instagram')], ['LINKEDIN', I18nText('socialNetworkUrls.linkedIn')], ['YOUTUBE', I18nText('socialNetworkUrls.youTube')]],
      default: 'FACEBOOK',
      display: 'select',
      id: 'social_network__networkType',
      label: I18nText('socialNetworkUrls.networkType.label'),
      name: 'networkType',
      type: 'choice',
      required: true,
      _requiresPreviewRefresh: true,
      _validate: (socialNetworkTypeValue, keyPath, oldModuleValues) => {
        if (oldModuleValues) {
          const socialNetworkIndex = keyPath[2];
          const networkValue = oldModuleValues.getIn(['knowledgeBaseSettings', 'socialNetworkUrls'])[socialNetworkIndex];
          return {
            [`socialNetworkUrl-${socialNetworkIndex}`]: validateUrl(networkValue.url, 'socialNetworkUrl', {
              networkType: getNetworkTypeText(socialNetworkTypeValue)
            })
          };
        }
        return {};
      }
    }, {
      default: '',
      id: 'social_network__url',
      label: I18nText('socialNetworkUrls.url.label'),
      name: 'url',
      required: true,
      type: 'text',
      _validate: (socialNetworkUrlValue, keyPath, oldModuleValues) => {
        if (oldModuleValues) {
          const socialNetworkIndex = keyPath[2];
          const networkValue = oldModuleValues.getIn(['knowledgeBaseSettings', 'socialNetworkUrls'])[socialNetworkIndex];
          return {
            [`socialNetworkUrl-${socialNetworkIndex}`]: validateUrl(socialNetworkUrlValue, 'socialNetworkUrl', {
              networkType: getNetworkTypeText(networkValue.networkType)
            })
          };
        }
        return {};
      }
    }],
    default: [{
      networkType: 'facebook'
    }],
    max_depth: 0,
    occurrence: {
      default: 1,
      min: 0,
      max: null,
      sorting_label_field: 'social_network__networkType'
    },
    type: 'group',
    _requiresPreviewRefresh: true,
    _validate: (socialNetworksValues, keyPath, oldModuleValues) => {
      const errors = {};
      if (oldModuleValues) {
        const oldSocialNetworksValues = oldModuleValues.getIn(keyPath);
        for (let idx = 0; idx < oldSocialNetworksValues.length; idx++) {
          // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          errors[`socialNetworkUrl-${idx}`] = undefined;
        }
      }
      socialNetworksValues.reduce((urlErrors, value, idx) => {
        urlErrors[`socialNetworkUrl-${idx}`] = validateUrl(value.url, 'socialNetworkUrl', {
          networkType: getNetworkTypeText(value.networkType)
        });
        return urlErrors;
      }, errors);
      return errors;
    }
  }];
  return {
    fields: [{
      id: 'knowledgeBaseSettings__footer',
      name: 'knowledgeBaseSettings',
      type: 'group',
      children
    }, {
      id: 'themeSettings__footer',
      name: 'themeSettings',
      type: 'group',
      children: [{
        id: 'social_icon_shape_and_color',
        name: 'social_icon_shape_and_color',
        label: I18nText('socialIconStyle.label'),
        type: 'social_icon_shape_and_color',
        _requiresPreviewRefresh: true
      }]
    }]
  };
};
const getGlobalStylesModule = ({
  indexTemplatePath
}) => {
  return {
    fields: [{
      id: 'themeSettings__themeType',
      name: 'themeSettings',
      label: I18nText('templateType.label'),
      type: 'group',
      expandable: true,
      defaultOpen: true,
      children: [{
        name: 'theme_type',
        label: null,
        type: 'theme_type'
      }]
    }, {
      id: 'themeSettings__buttonStyles',
      name: 'themeSettings',
      label: I18nText('buttonStyles.label'),
      type: 'group',
      expandable: true,
      defaultOpen: false,
      children: [{
        name: 'links_color',
        label: I18nText('linksColor.label'),
        help_text: I18nText('linksColor.helpText'),
        type: 'color'
      }, {
        name: 'nav_bar_link_color',
        label: I18nText('navBarLinkColor.label'),
        help_text: I18nText('navBarLinkColor.helpText'),
        type: 'color'
      }, {
        name: 'mobile_nav_menu_color',
        label: null,
        _templatePath: indexTemplatePath,
        type: 'color_with_mobile_preview'
      }]
    }, {
      id: 'themeSettings__fontStyles',
      name: 'themeSettings',
      label: I18nText('fontStyles.label'),
      type: 'group',
      expandable: true,
      defaultOpen: false,
      children: [{
        name: 'headings_font',
        label: I18nText('headingsFont.label'),
        help_text: I18nText('headingsFont.helpText'),
        load_external_fonts: true,
        showFontFamilyPickerOnly: true,
        type: 'font'
      }, {
        name: 'article_body_font',
        label: I18nText('articleBodyFont.label'),
        load_external_fonts: true,
        showFontFamilyPickerOnly: true,
        type: 'font'
      }, {
        name: 'toc_font',
        label: I18nText('tocFont.label'),
        load_external_fonts: true,
        showFontFamilyPickerOnly: true,
        type: 'font'
      }, {
        name: 'breadcrumbs_font',
        label: I18nText('breadcrumbsFont.label'),
        load_external_fonts: true,
        showFontFamilyPickerOnly: true,
        type: 'font'
      }]
    }]
  };
};
const getHeaderModule = () => {
  return {
    fields: [{
      id: 'knowledgeBaseSettings__header',
      name: 'knowledgeBaseSettings',
      type: 'group',
      children: [{
        name: 'welcomeMessage',
        label: I18nText('welcomeMessage.label'),
        help_text: I18nText('welcomeMessage.helpText'),
        type: 'text',
        placeholder: I18nText('welcomeMessage.placeholder')
      }]
    }, {
      id: 'themeSettings__header',
      name: 'themeSettings',
      type: 'group',
      children: [{
        name: 'header_welcome_message_color',
        label: I18nText('welcomeMessageTextColor.label'),
        help_text: I18nText('welcomeMessageTextColor.helpText'),
        type: 'color'
      }]
    }, {
      name: 'header_background_preview',
      type: 'header_background_preview',
      label: null
    }]
  };
};
const getHeaderBackgroundModule = () => {
  return {
    fields: [{
      id: 'knowledgeBaseSettings__headerBackground',
      name: 'knowledgeBaseSettings',
      type: 'group',
      children: [{
        name: 'headerBackground',
        type: 'headerBackground',
        label: null
      }]
    }]
  };
};
const getAllModuleSpecs = options => {
  return [getHeaderModule(), getHeaderBackgroundModule(), getGlobalStylesModule(options), getNavBarModule(options), getFooterModule()];
};
export const getModuleSpec = (navItem, options) => {
  switch (navItem) {
    case NAV_ITEMS.NAV_BAR:
      return getNavBarModule(options);
    case NAV_ITEMS.FOOTER:
    case NAV_ITEMS.EDIT_SOCIAL:
    case NAV_ITEMS.EDIT_FOOTER_LINKS:
      return getFooterModule();
    case NAV_ITEMS.GLOBAL_STYLES:
      return getGlobalStylesModule(options);
    case NAV_ITEMS.HEADER:
      return getHeaderModule();
    case NAV_ITEMS.HEADER_BACKGROUND:
      return getHeaderBackgroundModule();
    default:
      return null;
  }
};
const getFieldDefinitionByFieldPath = (fieldPath, options) => {
  const allModuleSpecs = getAllModuleSpecs(options);
  let field;
  for (const moduleSpec of allModuleSpecs) {
    // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
    const rootField = moduleSpec.fields.find(f => f.name === fieldPath[0]);
    if (!rootField) {
      continue;
    }
    const targetField = fieldPath.slice(1).reduce((node, nextKey) => {
      const nextNode = node.children.find(f => f.name === nextKey);
      return node.occurrence && !nextNode ? node : nextNode;
    }, rootField);
    if (targetField) {
      field = targetField;
      break;
    }
  }
  return field;
};
export const getFieldDefinition = (fieldPath, navItem) => {
  // Enable all options -> this function is only used for validating/updating values
  const options = {
    hasSupportForm: true,
    shouldShowCustomerPortalLinkToggle: true,
    shouldShowSignInLinkToggle: true,
    supportFormId: 'supportFormId'
  };
  if (!navItem) {
    return getFieldDefinitionByFieldPath(fieldPath, options);
  }

  // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
  const rootField = getModuleSpec(navItem, options).fields.find(f => f.name === fieldPath[0]);
  const targetField = fieldPath.slice(1).reduce((node, nextKey) => {
    const nextNode = node.children.find(f => f.name === nextKey);
    return !!node.children && !nextNode ? node : nextNode;
  }, rootField);
  return targetField;
};